import L from "leaflet";
import { useCallback, useEffect, useState } from "react";
import { useMap } from "../../providers/hooks/MapContext";

const LOCATION_DEBOUNCE_TIME = 1000;

const icon = L.icon({
  iconUrl: "images/pin.png",
  iconSize: [25, 32],
  iconAnchor: [20, 20],
  markerColor: "transparent",
});

export default function GoToLocationControl() {
  const map = useMap();
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [marker, setMarker] = useState(null);
  const [showMarker, setShowMarker] = useState(false);
  const [updateLocationDebounce, setUpdateLocationDebounce] = useState(null);
  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    if (map) {
      map.whenReady(() => setMapReady(true));
    }
  }, [map]);

  // When map is ready, show marker
  useEffect(() => {
    if (mapReady) {
      setShowMarker(true);
    } else {
      setShowMarker(false);
    }
  }, [mapReady]);

  // Add customer marker to map
  useEffect(() => {
    if (map && !marker) {
      setMarker(L.marker({ lat: 0, lng: 0 }, { icon }).addTo(map));
    }
  }, [map, marker]);

  // Get customer data and start to watch customer position
  useEffect(() => {
    navigator.geolocation.watchPosition(
      (pos) => {
        setLatitude(pos?.coords?.latitude ?? 0);
        setLongitude(pos?.coords?.longitude ?? 0);
      },
      (err) => {
        console.error("error trying to watch user location {}", err.message);
      },
      { enableHighAccuracy: false, timeout: 5000, maximumAge: 0 }
    );
  }, []);

  // Track location to change customer marker position
  useEffect(() => {
    if (!updateLocationDebounce && !window.stopLocationTracking) {
      const debounce = setTimeout(() => {
        if (showMarker && (Object.keys(map._layers) || []).length > 0) {
          marker.setLatLng(new L.latLng(latitude, longitude));
        }
        setUpdateLocationDebounce(null);
      }, LOCATION_DEBOUNCE_TIME);
      setUpdateLocationDebounce(debounce);
    }
  }, [latitude, longitude, map, marker, showMarker, updateLocationDebounce]);

  const handleFlyToClick = useCallback(() => {
    map.flyTo({ lat: latitude, lng: longitude }, 14);
  }, [latitude, longitude, map]);

  return (
    <img
      src="images/my_location.png"
      style={{
        position: "fixed",
        zIndex: 1000,
        bottom: "2%",
        right: "0.5rem",
        width: "25px",
        height: "25px",
        backgroundColor: "#ffffff",
        border: "solid 3px rgb(177, 177, 177)",
        padding: "4px",
        borderRadius: "9px",
      }}
      alt="my location"
      onClick={handleFlyToClick}
      id="fly-to"
    />
  );
}
